import { Weapon, type WeaponConfig } from './Weapon';

const SHOTGUN_CONFIG: WeaponConfig = {
  id: 'shotgun',
  // economy W12, calibrated to budget=30+10L. Своп с узи W13: дробовик дешевле
  // (2000 vs 2500), потому что разблокируется раньше (L10 vs L15).
  price: 2000,
  fireRateMs: 700,
  bulletsPerShot: 7,
  spreadDeg: 12,
  soundKey: 'pistol_shot',
  soundVolume: 0.5,
  shakeShoot: {
    intensity: 0.008,
    duration: 120,
  },
  magazineSize: 6,
  reloadTimeMs: 1200,
  bulletWidth: 4,
  bulletHeight: 2,
  fireMode: 'single',
  recoilForce: 8,
};

export function createShotgun(): Weapon {
  return new Weapon(SHOTGUN_CONFIG);
}
